import { useEffect } from "react";

function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setMetaProp(property: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

/**
 * 按页面更新 document.title 与 meta description / og 标签
 */
export function useSeo(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMetaProp("og:title", title);
    setMetaProp("og:description", description);
    setMetaProp("twitter:title", title);
    setMetaProp("twitter:description", description);
    // 更新 canonical 指向当前路径
    const path = window.location.pathname;
    const canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute("href", `https://artchatter.github.io${path}`);
    }
  }, [title, description]);
}